import React from "react";
import "./ProductsPageCard.scss";
import { IProduct } from "../../../Interfaces/product";
import { Link } from "react-router-dom";

const ProductsPageCard: React.FC<{
  allProducts: IProduct[];
  isLoading: boolean;
}> = ({ allProducts, isLoading }) => {
  return (
    <>
      <div className="about_product_card_container">
        {!isLoading ? (
          allProducts.length !== 0 ? (
            <>
              {allProducts.map((product) => (
                <Link
                  to={`/product-details/${product._id}`}
                  key={product._id}
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  <div className="product_card">
                    <div className="img_wrapper">
                      <div className="product_img">
                        <img
                          src={product.images[0].replace(
                            "/upload/",
                            "/upload/f_auto,q_auto,c_fill,w_433,h_520/"
                          )}
                          alt="product"
                          width="433"
                          height="520"
                          loading="lazy"
                        />
                        <div className="img_bridge">New</div>
                      </div>
                    </div>
                    <div className="product_name">{product.name}</div>
                    <div className="product_price">
                      View Product -{" "}
                      <span className="text-[#FFA52F]">₹{product.price}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </>
          ) : (
            <div className="not_found_shoes_text">
              <div>
                We couldn't find the shoes you're looking for. They might no
                longer be available in our collection.
              </div>
            </div>
          )
        ) : (
          [...Array(12)].map((_, index) => {
            return (
              <div className="skeleton_card" key={index}>
                <div className="skeleton_image" />
                {/* <div className="skeleton_text short" /> */}
                <div className="skeleton_text" />
                <div className="skeleton_button" />
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default ProductsPageCard;
